import React, { useEffect, useState } from "react";
import homepagecover from "../../assets/homepagecover.png";
import HomeCommonCard from "../../components/homescreen/HomeCommonCard";
// import Mydetails from "../../assets/Mydetails.png";
// import Insuree from "../../assets/Insuree.png";
// import EmployeeDeclaration from "../../assets/EmployeeDeclaration.png";
// import Payment from "../../assets/Payment.png";
import StaffManagement from "../../assets/staffManagement.png";
import HealthFacility from "../../assets/healthFacility.png";
import Verification from "../../assets/verification.png";
import Claim from "../../assets/claim.png";
import PreAuth from "../../assets/preAuth.png";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
// import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
// import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import { useNavigate } from "react-router-dom";
import {
  CLAIM_PORTAL,
  FOSA_VERIFICATION,
  HEALTH_FACILITY,
  // POLICYHOLDER_DETAILS,
  // PORTAL_CONTRACT,
  // PORTAL_INSUREE,
  Pre_Autharization,
  STAFF_MANAGEMENT,
  ADMIN_USERS,
  // MENU_FEUILLE_DE_SOINS,
  // MENU_DEMANDE_DE_PAIEMENT,
  // MENU_GESTION_DU_PROFESSIONNEL_DE_SOINS,
  // MENU_VERIFICATION_DES_ASSURES,
  // MENU_GESTION_DES_ACCORDS_PREALABLES,
  // MENU_ADMINISTRATEUR,
  HAS_PERMISSION_TO_VIEW_PAGE,
  PATH_NAME_PERMISSIONS,
} from "../../utils/constant";
// import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
// import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import { styled } from "@mui/material/styles";
import HomepageHeader from "../../reusableComponents/components/generics/HomepageHeader";
import FingerprintOutlinedIcon from "@mui/icons-material/FingerprintOutlined";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import HandshakeIcon from "@mui/icons-material/Handshake";
import DomainAddOutlinedIcon from "@mui/icons-material/DomainAddOutlined";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import { useDispatch, useSelector } from "react-redux";
// import { loadingUser } from "../../action";

const Content = styled("div")(({ theme }) => ({
  flexGrow: 1,
  paddingRight: theme.jrnlDrawer.close.width - theme.spacing(1),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

function HomePage() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.profileReducer);
  const fosaInfo = useSelector((state) => state.fosaReducer);
  const [loading, setLoading] = useState(true); // Loading state
  // const token = localStorage.getItem("token");
  // const dispatch = useDispatch();

  const isFosa = userInfo?.currentUserResponseData?.i_user?.health_facility_id;
  const fosaPermission = fosaInfo?.fosaUserData?.[0]?.iUser;

  const currentUserRoles = useSelector(
    (state) => state.profileReducer.currentUserRoles?.roles
  );

  useEffect(() => {
    const storedLanguage = localStorage.getItem("selectedLanguage");
    if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
  }, [i18n]);

  useEffect(() => {
    if (isFosa !== undefined && fosaPermission !== undefined) {
      setLoading(false);
    }
  }, [isFosa, fosaPermission]);

  const fosaEmpPermissions = fosaPermission?.fosaEmpPermissions
    ? fosaPermission.fosaEmpPermissions.split(",").map(Number)
    : [];

  console.log(fosaPermission, "fosaEmpPermissions");

  return (
    <HomepageHeader
      noSidebar={true}
      children={
        <Content>
          <Grid container>
            <img
              src={homepagecover}
              alt="homecoverpage"
              className="home-cover"
            />
            {!loading && (
              <Grid
                container
                className="home-card"
                sx={{ width: "90%", marginLeft: "5%" }}
                spacing={4}
              >
                {!!isFosa && (
                  <>
                    <Grid item xs={3}>
                      <HomeCommonCard
                        image={HealthFacility}
                        title={t("healthFacility")}
                        description={t("healthFacilitySubtitle")}
                        backgroundColor="#CFDDFF"
                        Icon={
                          <DomainAddOutlinedIcon
                            sx={{ fontSize: 80, color: "#ffff" }}
                          />
                        }
                        handleNavigate={() => navigate(HEALTH_FACILITY)}
                      />
                    </Grid>
                    {fosaPermission?.isFosaEmp ? (
                      <>
                        {fosaEmpPermissions.includes(1) &&
                          HAS_PERMISSION_TO_VIEW_PAGE(
                            PATH_NAME_PERMISSIONS,
                            CLAIM_PORTAL,
                            currentUserRoles
                          ) && (
                            <Grid item xs={3}>
                              <HomeCommonCard
                                image={Claim}
                                title={t("claimTitle")}
                                description={t("claimSubtitle")}
                                backgroundColor="#FFD4B5"
                                Icon={
                                  <PostAddOutlinedIcon
                                    sx={{ fontSize: 80, color: "#ffff" }}
                                  />
                                }
                                handleNavigate={() => navigate(CLAIM_PORTAL)}
                              />
                            </Grid>
                          )}
                        {fosaEmpPermissions.includes(2) &&
                          HAS_PERMISSION_TO_VIEW_PAGE(
                            PATH_NAME_PERMISSIONS,
                            STAFF_MANAGEMENT,
                            currentUserRoles
                          ) && (
                            <Grid item xs={3}>
                              <HomeCommonCard
                                image={StaffManagement}
                                title={t("staffTitle")}
                                description={t("staffSubtitle")}
                                backgroundColor="#DDED9F"
                                Icon={
                                  <ManageAccountsOutlinedIcon
                                    sx={{ fontSize: 80, color: "#ffff" }}
                                  />
                                }
                                handleNavigate={() =>
                                  navigate(STAFF_MANAGEMENT)
                                }
                              />
                            </Grid>
                          )}
                        {fosaEmpPermissions.includes(3) &&
                          HAS_PERMISSION_TO_VIEW_PAGE(
                            PATH_NAME_PERMISSIONS,
                            FOSA_VERIFICATION,
                            currentUserRoles
                          ) && (
                            <Grid item xs={3}>
                              <HomeCommonCard
                                image={Verification}
                                title={t("verificationTitle")}
                                description={t("verificationSubtitle")}
                                backgroundColor="#F2CFFF"
                                Icon={
                                  <FingerprintOutlinedIcon
                                    sx={{ fontSize: 80, color: "#ffff" }}
                                  />
                                }
                                handleNavigate={() =>
                                  navigate(FOSA_VERIFICATION)
                                }
                              />
                            </Grid>
                          )}
                        {HAS_PERMISSION_TO_VIEW_PAGE(
                          PATH_NAME_PERMISSIONS,
                          Pre_Autharization,
                          currentUserRoles
                        ) && (
                          <Grid item xs={3}>
                            <HomeCommonCard
                              image={PreAuth}
                              title={t("preAuthTitle")}
                              description={t("preAuthSubtitle")}
                              backgroundColor="#FFCAE7"
                              Icon={
                                <FingerprintOutlinedIcon
                                  sx={{ fontSize: 80, color: "#ffff" }}
                                />
                              }
                              handleNavigate={() => navigate(Pre_Autharization)}
                            />
                          </Grid>
                        )}
                      </>
                    ) : (
                      <>
                        {HAS_PERMISSION_TO_VIEW_PAGE(
                          PATH_NAME_PERMISSIONS,
                          CLAIM_PORTAL,
                          currentUserRoles
                        ) && (
                          <Grid item xs={3}>
                            <HomeCommonCard
                              image={Claim}
                              title={t("claimTitle")}
                              description={t("claimSubtitle")}
                              backgroundColor="#FFD4B5"
                              Icon={
                                <PostAddOutlinedIcon
                                  sx={{ fontSize: 80, color: "#ffff" }}
                                />
                              }
                              handleNavigate={() => navigate(CLAIM_PORTAL)}
                            />
                          </Grid>
                        )}

                        {HAS_PERMISSION_TO_VIEW_PAGE(
                          PATH_NAME_PERMISSIONS,
                          STAFF_MANAGEMENT,
                          currentUserRoles
                        ) && (
                          <Grid item xs={3}>
                            <HomeCommonCard
                              image={StaffManagement}
                              title={t("staffTitle")}
                              description={t("staffSubtitle")}
                              backgroundColor="#DDED9F"
                              Icon={
                                <ManageAccountsOutlinedIcon
                                  sx={{ fontSize: 80, color: "#ffff" }}
                                />
                              }
                              handleNavigate={() => navigate(STAFF_MANAGEMENT)}
                            />
                          </Grid>
                        )}

                        {HAS_PERMISSION_TO_VIEW_PAGE(
                          PATH_NAME_PERMISSIONS,
                          FOSA_VERIFICATION,
                          currentUserRoles
                        ) && (
                          <Grid item xs={3}>
                            <HomeCommonCard
                              image={Verification}
                              title={t("verificationTitle")}
                              description={t("verificationSubtitle")}
                              backgroundColor="#F2CFFF"
                              Icon={
                                <FingerprintOutlinedIcon
                                  sx={{ fontSize: 80, color: "#ffff" }}
                                />
                              }
                              handleNavigate={() => navigate(FOSA_VERIFICATION)}
                            />
                          </Grid>
                        )}

                        {HAS_PERMISSION_TO_VIEW_PAGE(
                          PATH_NAME_PERMISSIONS,
                          Pre_Autharization,
                          currentUserRoles
                        ) && (
                          <Grid item xs={3}>
                            <HomeCommonCard
                              image={PreAuth}
                              title={t("preAuthTitle")}
                              description={t("preAuthSubtitle")}
                              backgroundColor="#024CAA"
                              Icon={
                                <HandshakeIcon
                                  sx={{ fontSize: 80, color: "#ffff" }}
                                />
                              }
                              handleNavigate={() => navigate(Pre_Autharization)}
                            />
                          </Grid>
                        )}

                        {HAS_PERMISSION_TO_VIEW_PAGE(
                          PATH_NAME_PERMISSIONS,
                          ADMIN_USERS,
                          currentUserRoles
                        ) && (
                          <Grid item xs={3}>
                            <HomeCommonCard
                              image={PreAuth}
                              title={t("adminManagement.title")}
                              description={t("adminManagement.description")}
                              backgroundColor="#3A6D8C"
                              Icon={
                                <AdminPanelSettingsIcon
                                  sx={{ fontSize: 80, color: "#ffff" }}
                                />
                              }
                              handleNavigate={() => navigate(ADMIN_USERS)}
                            />
                          </Grid>
                        )}
                      </>
                    )}
                  </>
                )}
              </Grid>
            )}
          </Grid>
        </Content>
      }
    />
  );
}

export default HomePage;
